export default __webpack_public_path__ + "static/logo-dde96395001f3a50dfc6d509b9912f60.png";